import index from './jumbotron'

export default index